{
  "version": 1,
  "asset_id": "334ea2ec-e16c-49f3-9b0b-a55ab9f740ce",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/334ea2ec-e16c-49f3-9b0b-a55ab9f740ce/horizontal.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/334ea2ec-e16c-49f3-9b0b-a55ab9f740ce/horizontal.png",
  "original_filename": "horizontal.png",
  "size": 259896,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:44:30Z"
}
